import client from "graphql/client";
import i18next from "i18next";
import { loader } from "graphql.macro";
import { BOOK_LOADED } from "redux/types";
import { snackbarSuccess, snackbarError } from "shared/redux/actions/Snackbar";
import createBookFromData from "helpers/createBookFromData";

const addBookMeasure = loader("graphql/mutations/books/addBookMeasure.graphql");

const mapTaskForMutation = (task) => {
    const checklistId = task?.checklistId || task?.checklist?.id;
    const mappedTask = { ...task };

    delete mappedTask.checklist;

    if (checklistId) {
        mappedTask.checklist = checklistId;
    } else {
        delete mappedTask.checklistId;
    }

    return mappedTask;
};

export default function bookMeasureAdd(osbn, measure) {
    return async (dispatch, getState) => {
        const { current: organisation } = getState().organisation;
        const mappedTasks = Array.isArray(measure?.tasks)
            ? measure.tasks.map(mapTaskForMutation)
            : [];

        try {
            const { data } = await client.mutate({
                mutation: addBookMeasure,
                variables: {
                    organisationId: organisation.id,
                    osbn,
                    measure: {
                        ...measure,
                        tasks: mappedTasks
                    }
                },
            });

            const { addBookMeasure: bookData } = data;

            const book = createBookFromData(bookData);

            dispatch({
                type: BOOK_LOADED,
                id: osbn,
                book
            });
            
            dispatch(snackbarSuccess(i18next.t("books.edit.success")));

        } catch (error) {
            console.error(error);
            dispatch(snackbarError(i18next.t("books.edit.failed")));
        }
    };
}
